const theme = {
  colors: {
    primary: "#FCD200",
    white: "#FFFFFF",
    black: "#2B2B33",
    boxShadow: "#2b2b334a",
    lightGray: "#e2e2e2",
    gray: "#6d6d6d",
    error: "#FC1D0D",
  },
  fonts: {
    header: "Oswald",
  },
  boxShadows: {
    dark: "0px 0px 15px 0px #10101094",
    light: "0px 0px 11px 4px #d2d2d294",
  },
  navigation: {
    height: 90,
  },
};

export default theme;
